import React from 'react';
import { Outlet } from 'react-router-dom';
import AnnouncementBar from './AnnouncementBar';
import Navbar from './Navbar';
import Topbar from './Topbar';
import Footer from './Footer';
import ScrollToTop from '../components/ScrollToTop';
import ScrollRestoration from '../components/ScrollRestoration';
import PageLoader from '../components/PageLoader';
import usePageTransition from '../Hooks/usePageTransition';
import './Layout.css';

const Layout = () => {
  const isLoading = usePageTransition();

  return (
    <div className="layout-wrapper">
      {isLoading && <PageLoader />}
      <ScrollRestoration />
      {/* <AnnouncementBar /> */}
      {/* <Topbar /> */}
      <Navbar />
      <main className="main-content">
        <Outlet />
      </main>
      <Footer />
      <ScrollToTop />
    </div>
  );
};

export default Layout;
